import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  H2,
  Modal,
} from "@datapay-by-datacom/design-system";
import { Button } from "@datapay-by-datacom/design-system";
import { useState } from "react";
import styles from "./Disclaimer.module.css";

const DISCLAIMER_PARAGRAPHS = [
  `Welcome to our AI Payroll Assistant. Please be aware that this service uses artificial intelligence to interpret and provide information based on your queries and the data available to it.`,
  `While we strive to keep the AI's knowledge current with New Zealand payroll legislation, we cannot guarantee complete accuracy due to the potential for laws and interpretation to change.`,
  `Please note that this service does not offer or constitute legal advice, and we are not qualified lawyers. For specific concerns, particularly if your situation is unusual or you seek complete peace of mind, we recommend consulting with a professional legal advisor.`,
  `To the extent permitted by law, Datacom disclaims any and all liability arising in any way from the use of this service.`,
];

export const Disclaimer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        className={styles.disclaimerTrigger}
        onClick={handleOpen}
      >
        Disclaimer
      </button>

      <Modal isOpen={isOpen}>
        <div className={styles.card}>
          <Card>
            <CardHeader>
              <H2>Disclaimer</H2>
            </CardHeader>
            <CardBody>
              {DISCLAIMER_PARAGRAPHS.map((paragraph, index) => (
                <p key={index} className={styles.paragraph}>
                  {paragraph}
                </p>
              ))}
            </CardBody>

            <CardFooter>
              <Button variant="primary" onPress={handleClose}>
                Close
              </Button>
            </CardFooter>
          </Card>
        </div>
      </Modal>
    </>
  );
};
